import { useState } from "react";
import { Box, Grid } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { mainContentStyle } from "./mainContentStyle";
import FullImage from "../MainContent/FullImage";

const SectionTen = () => {
  const classes = mainContentStyle();
  const [fullImage, setFullImage] = useState("");
  const [showFullImage, setShowFullImage] = useState(false);

  return (
    <>
      <Box
        sx={{
          paddingRight: { xs: "10px", sm: "10px", md: "70px", lg: "70px" },
          paddingLeft: { xs: "10px", sm: "10px", md: "70px", lg: "70px" },
          maxWidth: "1700px",
          marginRight: "auto",
          marginLeft: "auto",
        }}
      >
        <Box
          className={classes.section4Cntnt}
          style={{ position: "relative" }}
          sx={{
            minHTen: "350px",
            display: { xs: "block", sm: "block", md: "flex", lg: "flex" },
            paddingLeft: { xs: "24px", sm: "24px", md: "24px", lg: "24px" },
            paddingRight: { xs: "24px", sm: "24px", md: "24px", lg: "24px" },
          }}
        >
          <Grid
            item
            lg={6}
            style={{ textAlign: "left", margin: "auto" }}
            sx={{
              display: { xs: "none", sm: "none", md: "none", lg: "block" },
            }}
          >
            <div className="row justify-content-end w-100 ml-0 mr-0">
              <div style={{ textAlign: "right" }}>
                <LazyLoadImage
                  onClick={() => {
                    if (window.innerWidth > window.innerHeight) {
                      setFullImage("/images/sec-img2.jpg");
                      setShowFullImage(true);
                    }
                  }}
                  className="main-img scale-img"
                  alt="..."
                  width="620"
                  height="620"
                  src={process.env.PUBLIC_URL + "/images/sec-img2.jpg"}
                  // style={{
                  //   margin: "auto",
                  //   position: "absolute",
                  //   top: "50px",
                  // }}
                  style={{
                    // width: "500px",
                    margin: "auto",
                    position: "absolute",
                    top: "50px",
                    width: "620",
                    height: "620",
                    maxWidth: "100%",
                    objectFit: "cover",
                    // height: "100%",
                    minHeight: "300px",
                    cursor:
                      `url(${
                        process.env.PUBLIC_URL + "/images/cursor-scale.png"
                      })` + ", auto",
                  }}
                />
              </div>
            </div>
          </Grid>
          <Grid
            item
            lg={6}
            style={{ textAlign: "left", margin: "auto" }}
            sx={{
              display: { xs: "block", sm: "block", md: "block", lg: "none" },
            }}
          >
            <div className="row justify-content-end w-100 ml-0 mr-0 mb-5">
              <div style={{ textAlign: "right" }}>
                <LazyLoadImage
                  className="main-img"
                  width="100%"
                  height="auto"
                  alt="..."
                  src={process.env.PUBLIC_URL + "/images/sec-img2.jpg"}
                  style={{
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <div className="row justify-content-center w-100 ml-0 mr-0">
              <Grid item lg={10} md={12} sm={12} xs={12}>
                <div className="row ml-0 mr-0" style={{ paddingTop: "62px" }}>
                  <div
                    className={classes.section4Hdr}
                    style={{ textAlign: "center" }}
                  >
                    با سیگما، تعویض خودرو دیگر دغدغه شما نیست!
                  </div>
                </div>
                <div
                  className="row justify-content-center ml-0 mr-0"
                  style={{ marginTop: "40px" }}
                >
                  <Grid item lg={11} md={11} sm={12} xs={12}>
                    <div className={classes.section4Text}>
                      از دوندگی برای فروش خودرو خسته شده‌اید؟می خواهید خودروی
                      خود را تعویض کنید؟ سیگما با یک فرایند ساده و کارشناسی
                      حرفه‌ای، خودروی کرمان موتوری شما را در کمترین زمان به فروش
                      می‌رساند و با انتخاب گسترده‌ای از خودروهای کارکرده و صفر
                      همین برند،این امکان را برای شما فراهم کرده تا به راحتی و
                      با اطمینان خاطر، خودروی خود را تعویض کنید.
                    </div>
                  </Grid>
                </div>
              </Grid>
            </div>
          </Grid>
        </Box>
      </Box>
      {showFullImage && (
        <FullImage
          imageUrl={process.env.PUBLIC_URL + fullImage}
          closeImage={() => {
            setFullImage("");
            setShowFullImage(false);
          }}
        />
      )}
    </>
  );
};
export default SectionTen;
